// extracted by mini-css-extract-plugin
module.exports = {"ADR":"ADR_ADR__pLbmZ","inputWrapper":"ADR_inputWrapper__kV_ph","suggestion":"ADR_suggestion__pnuzn","suggestionDescription":"ADR_suggestionDescription__MosLj"};